import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import { columntype, inputType, isValidArray } from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  ManageCourseFiles,
  DeleteEventsMediaGallery,
  GetCourseFiles,
} from "./actions";
import { useParams } from "react-router";
import { GetCourses } from "../courses/actions";

const CourseFiles = () => {
  const { id } = useParams();
  console.log(id);
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("required"),
    description: Yup.string().trim().required("required"),
    image: Yup.string().trim().required("required"), // COVER IMAGE
    course_id: Yup.string().trim().required("required"),
    // video_duration: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetCourseFiles({
        limit: rowsPerPage,
        page: page,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    dispatch(
      GetCourses({
        page: 0,
        rowsPerPage: 500,
        callback: (data) => {
          console.log({ datadata: data.data });
          if (isValidArray(data?.data)) {
            if (array.length == 0) {
              setarray([
                {
                  failed: "id",
                  type: inputType.text,
                  title: "id",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { display: "none" },
                },
                {
                  failed: "course_id",
                  type: inputType.dropdown,
                  title: "Course",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  datadropdown: data?.data,
                  faileddropdown: {
                    name: "name",
                    value: "id",
                  },
                },
                {
                  failed: "name",
                  type: inputType.text,
                  title: "Name",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "url",
                  type: inputType.text,
                  title: "URL",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "video_duration",
                  type: inputType.text,
                  title: "Video Duration",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },

                {
                  failed: "description",
                  type: inputType.editor,
                  title: "Description",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },

                {
                  failed: "path",
                  type: inputType.image,
                  title: "Path",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  // cover image
                  failed: "image",
                  type: inputType.image,
                  title: "Cover Image",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
              ]);
            }
          }
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "name" },
    { type: columntype.text, name: "url" },
    { type: columntype.image, name: "image" },
    { type: columntype.html, name: "description" },
    { type: columntype.image, name: "path" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      withSort: false,
    },
    {
      id: "url",
      numeric: false,
      disablePadding: false,
      label: "URL",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Cover Image",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "path",
      numeric: false,
      disablePadding: false,
      label: "Path",
      withSort: false,
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.title ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteEventsMediaGallery({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaTypeId: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(id) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteEventsMediaGallery({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaTypeId: id,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={true}
        withDeleteItem={false}
        withEditItem={true}
        withPagination={true}
        withSearch={false}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Course files"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new Course file"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageCourseFiles({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default CourseFiles;
